import React, { useState, useRef, useContext, useEffect } from "react";
import { assetUrl } from "../../../../Utils/assetUrl";
import Lottie from "lottie-web";
import MyContext from "../../../../context/MyContext";
import AuthContext from "../../../../context/userAuth.context";
import TickerContext from "../../../../context/ticker";
import axios from "axios";
import swal from "sweetalert";
import ProjectContext from "../../../../context/ProjectContext";

const StaticCharacter = (props) => {
  var ActiveFrame = {
    Male: {
      Default: { frame: 0 },
      Happy: { frame: 50 },
      Sad: { frame: 37 },
      Satisfied: { frame: 60 },
      Wave: { frame: 33 },
      Angry: { frame: 33 },
      Walk: { frame: 33 },
      Talking: { frame: 33 },
      Clap: { frame: 33 },
      Thinking: { frame: 33 },
    },

    Female: {
      Default: { frame: 0 },
      Happy: { frame: 50 },
      Sad: { frame: 37 },
      Satisfied: { frame: 60 },
      Wave: { frame: 100 },
      Angry: { frame: 33 },
      Walk: { frame: 33 },
      Talking: { frame: 33 },
      Clap: { frame: 60 },
      Thinking: { frame: 180 },
    },
  };

  const { authenticationData, Role } = useContext(AuthContext);

  const { charcterFolder, setcharcterFolder, Goto, setGoto, TickerPosition } =
    useContext(TickerContext);

  const { slides, setslides } = useContext(ProjectContext);

  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    setCharacterData,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    setChangeCount,
    calculateWidthByDuration,
    ChangeCount,
    Tl_TotalTime,
    EditorZoom,
    seteditableObject,
  } = useContext(MyContext);

  var cName = props.obj.Name + "mini";

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const playref = useRef(null);

  const imgref = useRef(null);

  const [PlayCharacter, setPlayCharacter] = useState(false);

  const [delayHandler, setDelayHandler] = useState(null);

  const [delayHandler2, setDelayHandler2] = useState(null);

  const [Gender, setGender] = useState();

  const [poseList, setposeList] = useState(null);

  useEffect(() => {
    if (!Gender) {
      let split = props.obj.FilePath.split("/");
      let splitName = split[split.length - 1];
      if (splitName.includes("Female")) {
        setGender("Female");
        //console.log('female');
      } else {
        setGender("Male");
        //console.log('male');
      }
    }
    let PArr = [];

    for (const itr of props.obj.poses) {
      let obj = {
        poseFile: itr.poseFile,
        poseLargeImg: itr.poseImg,
        poseName: itr.poseName,
        poseSmallImg: itr.poseImg,
      };
      PArr.push(obj);
    }
    setposeList(PArr);
  }, []);

  const MouseOnChr = (event, FileName, name) => {
    setDelayHandler(
      setTimeout(() => {
        PlayByPath(FileName, name);
      }, 800)
    );

    // var offsets = event.target.getBoundingClientRect();
    // var leftside = Math.round(offsets.x + offsets.width);
    // var topside = Math.round(offsets.y);

    // let ChangePose = false;
    // let prvKey = null;

    // let gender = Gender;

    // setDelayHandler2(
    //   setTimeout(() => {
    //     props.setChrPopData({ left: leftside, top: topside });
    //     setCharacterData({
    //       poseList,
    //       gender,
    //       name,
    //       FileName,
    //       ChangePose,
    //       prvKey,
    //     });
    //     props.setchrPop(true);
    //   }, 1500)
    // );
  };

  const showActions = (event, FileName, name) => {
    if (event.target.id == "actions") {
      var offsets = event.target.getBoundingClientRect();
      var leftside = Math.round(offsets.x + offsets.width);
      var topside = Math.round(offsets.y);

      let ChangePose = false;
      let prvKey = null;

      let gender = Gender;

      setDelayHandler2(
        setTimeout(() => {
          props.setChrPopData({ left: leftside, top: topside });
          setCharacterData({
            poseList,
            gender,
            name,
            FileName,
            ChangePose,
            prvKey,
          });
          props.setchrPop(true);
        }, 500)
      );
    }
  };

  const PlayByPath = (path) => {
    try {
      if (!PlayCharacter) {
        Lottie.loadAnimation({
          container: playref.current,
          name: cName,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: assetUrl(authenticationData.ApiBaseURL, props.obj.FilePath),
          rendererSettings: {
            preserveAspectRatio: "xMidYMin meet",
            viewBoxOnly: true,
            progressiveLoad: true,
          },
          //rendererSettings: {
          //context: ctx,
          //clearCanvas: true,
          //}
        });
        setPlayCharacter(true);
        playref.current.style.display = "block";
        imgref.current.style.display = "none";
      } else {
        Lottie.play(cName);
        playref.current.style.display = "block";
        imgref.current.style.display = "none";
      }
    } catch {
    }
  };

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  const mouseleave = async () => {
    clearTimeout(delayHandler);
    clearTimeout(delayHandler2);

    if (PlayCharacter) {
      Lottie.play(cName);
    }

    playref.current.style.display = "none";
    imgref.current.style.display = "block";
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const addCharacter = (event, gender) => {
    //if conditions is to prevent parent action on child element click
    if (event.target.offsetParent) {
      if (
        event.target.id === "actions" ||
        event.target.id === "upload" ||
        event.target.offsetParent.id === "upload" ||
        event.target.id === "delete" ||
        event.target.offsetParent.id == "delete"
      ) {
        return null;
      }
    }

    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;
    let _widthPercentage = 350 / CanvasWidth;
    let _heightPercentage = 440 / canvasHeight;
    let _width = (CanvasWidth * _widthPercentage) / 2;
    let _height = (canvasHeight * _heightPercentage) / 2;

    var top = getRandomArbitrary(0, canvasHeight - _height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);

    if (PlayCharacter) {
      Lottie.stop(cName);
    }

    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    if (Goto.innerMenu == "Char") {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === Goto.key) {
          Lottie.destroy(array[i].AnimationId);
          array[i].character_FilePath = props.obj.FilePath;
          array[i].character_poses = props.obj.poses;
          array[i].ImageSrc = null;
          array[i].CharacterPlayed = false;
        }
      }
      setLayersData(array);
      setChangeCount(ChangeCount + 1);
      setGoto({
        menu: null,
        innerMenu: null,
        key: null,
      });
    } else {
      var topIndex = 0;

      if (LayersData.length > 0) {
        topIndex = LayersData[LayersData.length - 1].layerIndex;
        topIndex = topIndex + 1;
      }

      var typelength = 1;
      var checkKey = 0;

      for (var i = 0; i < LayersData.length; i++) {
        if (LayersData[i].Editable === true) {
          LayersData[i].Editable = false;
          LayersData[i].showDiv = false;
        }
        LayersData[i].toolbar = false;

        if (LayersData[i].type === "Character") {
          typelength = typelength + 1;
        }
        if (LayersData[i].key >= checkKey) {
          checkKey = LayersData[i].key;
        }
      }
      // let TickPos
      // let trans = document.getElementById('tickerHead').style.transform;
      // if (trans != "") {
      //     trans = trans.split('(')
      //     trans = trans[1].split(',')
      //     trans = trans[0].split('px')
      //     trans = eval(trans[0]);
      //     TickPos = trans;
      // }

      let currentTime = calculateTimeByWidth(TickerPosition);
      let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);

      let newEntryLayerData = {
        AnimationId: makeid(7),
        key: checkKey + 1,
        type: "Character",
        bgColor: "#00adff",
        Name: `Character-${typelength}`,
        canvas: null,
        userFile: "xyz",
        EditorZoom: EditorZoom,
        layerIndex: topIndex,
        index: null,
        TimelineZoom: timelineZoomVal,
        duration: totalTime,
        startTime: currentTime,
        endTime: calculateTimeByWidth(Tl_TotalTime.width),
        visible: true,
        OutEffect: "none",
        InEffect: "none",
        typeIcon: "person",
        character_poses: props.obj.poses,
        ImageSrc: props.obj.MiniImg,
        character_FilePath: props.obj.FilePath, //with out .json
        startTransitionWidth: 0,
        startTransitionLeft: 0,
        endTransitionWidth: 0,
        endTransitionLeft: 0,
        EditorZoom: EditorZoom,
        x: left,
        y: top,
        opacity: 1,
        originalOpacity: 1,
        width: _width,
        height: _height,
        toolbar: true,
        FurtherSetting: false,
        lock: false,
        layerlock: false,
        opc: 1,
        hidden: false,
        Editable: true,
        CharacterStop: true,
        CharacterPause: false,
        CharacterPlayed: false,
        startPositionOnTimeline: TickerPosition,
        player: false,
        Animate: false,
        flip: "scaleX(1)",
        rotateAngle: 0,
        originalX: null,
        AzData: null,
        startAtoZ: false,
        InMultiDrag: false,
        ImageFrame: 0,
        Added: true,
        showDiv: true,
        JSONValue: (async () => {
          const resp = await fetch(
            assetUrl(authenticationData.ApiBaseURL, props.obj.FilePath)
          );
          const jsonData = await resp.json();
          newEntryLayerData.JSONValue = jsonData;
          newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
            newEntryLayerData.duration
          );
          newEntryLayerData.endTransitionLeft =
            newEntryLayerData.widthOnTimeline -
            newEntryLayerData.endTransitionWidth;
          setLayersData(LayersData.concat(newEntryLayerData));
          seteditableObject({
            showPanel: true,
            editableItem: newEntryLayerData,
          });
          // let change = false;
          // const array = Array.from(slides)
          // for(let i = 0; i < array.length; i++)
          // {
          //     if(array[i].IsActive)
          //     {
          //         array[i].LayerData.push(newEntryLayerData)
          //         change = true;
          //     }
          // }

          // if(change)
          // {
          //     setTimeout(() => {
          //         setslides(array)
          //     }, 7000);

          // }

          setChangeCount(ChangeCount + 1);
          return jsonData;
        })(),
      };

      // console.log("chatr data path = " + newEntryLayerData.character_FilePath)
    }
  };

  const uploadGesture = (params) => {
    uploadref.current.click();
  };

  const deleteCharacter = (event) => {
    if (
      event.target.id == "delete" ||
      event.target.offsetParent.id == "delete"
    ) {
      swal({
        title: "Are you sure you want to delete.",
        text: "This character will be deleted permanently.",
        icon: "warning",
        buttons: [true, "Yes, Delete"],
        cancelButtonColor: "#d33",
        dangerMode: true,
      }).then((result) => {
        if (result) {
          axios
            .get(
              authenticationData.ApiBaseURL +
                `/api/Character/DeleteStaticCharacter?id=${props.obj.CharacterId}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + authData.access_token,
                },
              }
            )
            .then((response) => {
              if (response.data.result) {
              }

              let state = Array.from(charcterFolder);
              for (let i = 0; i < state.length; i++) {
                if (state[i].id == props.catid) {
                  let val = state[i].items.filter(function (value) {
                    if (value.CharacterId !== props.obj.CharacterId) {
                      return value;
                    }
                  });
                  state[i].items = val;
                }
              }
              setcharcterFolder(state);
              swal("Excellent", "deleted", "success");
            })
            .catch((error) => {
              //console.log(error);
            });
        }
      });
    }
  };

  const uploadref = useRef(null);

  const fileChangeHandle3 = (e) => {
    var formdata = new FormData();
    for (var i = 0; i < e.target.files.length; i++) {
      formdata.append("files", e.target.files[i]);
    }
    formdata.append("CategoryId", 3);
    formdata.append("id", props.obj.CharacterId);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Character/UploadStaticCharacterGestures",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          //console.log(response.data);

          let data = response.data.updateData;

          let gestures = JSON.parse(data.gesturePaths);
          let array = [];
          if (gestures != null) {
            for (let i = 0; i < gestures.length; i++) {
              let Pobj = { poseFile: "", poseName: "", poseImg: "" };
              Pobj.poseFile = gestures[i].jsonPath;
              Pobj.poseName = gestures[i].type;
              Pobj.poseImg = gestures[i].imgPath;
              array.push(Pobj);
            }
          }
          let state = Array.from(charcterFolder);
          for (let i = 0; i < state.length; i++) {
            if (state[i].id == data.categoryId) {
              for (let j = 0; j < state[i].items.length; j++) {
                if (state[i].items[j].CharacterId == data.id) {
                  state[i].items[j].poses = array;
                }
              }
            }
          }
          setcharcterFolder(state);
          swal("Excellent", "Image Has Been Uploaded", "success");
        } else {
          swal("Failed", "Unable to Upload Image. Please Try Again", "error");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          swal("Failed", error.response.data, "error");
        }
      });
  };

  var AssetItem = {
    display: "block",
    backgroundPosition: "center center",
    height: "115px",
    textAlign: "center",
    width: "95px",
  };

  return (
    <>
      <div
        id="character"
        style={AssetItem}
        className="AssetItemforCharacter"
        title="Click to add character"
        onClick={(event) => addCharacter(event, props.obj)}
        onMouseLeave={() => mouseleave()}
        onMouseEnter={(event) =>
          MouseOnChr(
            event,
            props.obj.FilePath,
            props.obj.Name,
            props.obj.MiniImg
          )
        }
      >
        {/* <canvas ref={playref} className='canv' width={100} height={100} style={{ display: 'none' }} /> */}
        <img
          ref={imgref}
          src={assetUrl(authenticationData.ApiBaseURL, props.obj.MiniImg)}
          alt=""
          style={{ width: "140px", height: "169px" }}
        />
        <div
          ref={playref}
          className="canv"
          style={{ width: "140px", height: "169px", display: "none" }}
        />
        <div
          id="actions"
          onClick={(event) =>
            showActions(
              event,
              props.obj.FilePath,
              props.obj.Name,
              props.obj.MiniImg
            )
          }
          className="showActions"
          title="Admin Gesture Upload"
        >
          Actions
        </div>

        {Role == "admin" && (
          <>
            <div
              id="upload"
              className="adminIconsUpload"
              title="Admin Gesture Upload"
              onClick={uploadGesture}
            >
              <span
                className="material-icons"
                style={{ fontSize: "14px", lineHeight: "12px" }}
              >
                file_upload
              </span>
            </div>

            <input
              ref={uploadref}
              type="file"
              hidden
              multiple
              onChange={fileChangeHandle3}
            />
            <div
              id="delete"
              className="adminIconsDelete"
              title="Admin Character Delete"
              onClick={(event) => deleteCharacter(event)}
            >
              <span
                className="material-icons"
                style={{ fontSize: "14px", lineHeight: "12px" }}
              >
                delete
              </span>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default StaticCharacter;
